/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CreatePortfolioPageService";
const log: any = LoggerModule.getInstance();

export class CreatePortfolioPageService {
  private static instance: CreatePortfolioPageService;
  private vapp: VApplication;
  private formData: any = [];
  private evidenceKanbanList: any = [];
  private createPortfolio: any = {};

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CreatePortfolioPageService {
    if (!CreatePortfolioPageService.instance) {
      CreatePortfolioPageService.instance = new CreatePortfolioPageService(
        props
      );
    }
    return CreatePortfolioPageService.instance;
  }

  public setFormData = (args: any) => {
    let tempFormData = [];
    if (this.formData.includes(args?.formData?.id)) {
      tempFormData = this.formData?.map((item) => {
        if (item?.id === args?.formData?.id) {
          return {
            ...args?.formData,
          };
        } else
          return {
            ...item,
          };
      });
    } else {
      tempFormData.push({
        ...args?.formData,
      });
    }
    this.formData = tempFormData;
  };

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Template Form
    compProps = await agent.getPortfolioFormProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //   //Evidence Kanban Props
    //   compProps = await agent.getEvidenceKanbanProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //     this.evidenceKanbanList = compProps.evidenceKanbanList;
    //   }

    //   //CreateTemplate Props
    //   compProps = await agent.getCreateTemplateProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps, ...this.createPortfolio };
    //   }

    return content;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public submitCredentialForm(args: any) {
    console.log(`formdata in service`, args);
    this.setFormData(args);
    //   const agent = getAgent();
    //   return agent.getSubmitTemplate(args);
  }

  public getFormDefaultData() {
    console.log(`default data`, this.formData);
    return this.formData;
  }
}
